import React from 'react';
import PropTypes from 'prop-types';
import { HighlightTile } from 'web-ui-components/lib/molecules/tile';
import { FieldHeader } from 'web-ui-components/lib/molecules/forms';
import { iftFormValidationLength, treasuryNumber } from '../../../../config/ift';
import PreBookedReference from './PreBookedReference';
import PreBookedRate from './PreBookedRate';

export const PreBookedSection = (props) => {
	const {
		content: { header, description, exoticCurrencyDescription = '' },
		handleReferenceUpdate,
		handleRateUpdate,
		preBookedReference,
		exchangeRate,
		isPreBookedRateMandatory,
		...restProps
	} = props;
	const descriptionWithContactNumber = exoticCurrencyDescription.replace('{contactNumber}', treasuryNumber);
	return (
		<HighlightTile type="note">
			{isPreBookedRateMandatory && (
				<FieldHeader name="payment-content-description" description={descriptionWithContactNumber} />
			)}
			<FieldHeader name="payment-date" titleText={header} description={description} />
			<PreBookedReference
				preBookedReference={preBookedReference}
				onChange={handleReferenceUpdate}
				content={props.content}
				maxLength={iftFormValidationLength.preBookReferenceLength}
				minLength={iftFormValidationLength.preBookReferenceLength}
				{...restProps}
			/>
			<PreBookedRate preBookedRate={exchangeRate} onChange={handleRateUpdate} content={props.content} {...restProps} />
		</HighlightTile>
	);
};

PreBookedSection.propTypes = {
	content: PropTypes.shape({
		header: PropTypes.string.isRequired,
		description: PropTypes.string.isRequired,
		exoticCurrencyDescription: PropTypes.string.isRequired,
		referenceHeader: PropTypes.string.isRequired,
		exchangeRateHeader: PropTypes.string.isRequired,
	}),
	handleReferenceUpdate: PropTypes.func.isRequired,
	handleRateUpdate: PropTypes.func.isRequired,
	preBookedReference: PropTypes.string.isRequired,
	exchangeRate: PropTypes.string.isRequired,
	isPreBookedRateMandatory: PropTypes.bool.isRequired,
};
export default PreBookedSection;
